import React from 'react';
import {StyleSheet, View} from 'react-native';
import {observer} from 'mobx-react-lite';

import {useStores} from '../../../../stores/use-stores';
import CartItemsList from '../../components/CartItemsList';
import type {StepContentProps} from '../types';

/**
 * Left side content for Review step
 *
 * Contains:
 * - Cart items list (review mode)
 *
 * Note: PickupDeliveryDetails and CartCoupon are now in the right sidebar
 * (UnifiedCheckoutScreen) for web desktop layout.
 */
const ReviewContent = observer((_props: StepContentProps) => {
  const {cartStore} = useStores();

  return (
    <View style={styles.container}>
      <CartItemsList
        orderLines={cartStore.currentOrder?.order_lines}
        isLoading={cartStore.isLoadingOrder}
        testID="review-content-items-list"
      />
    </View>
  );
});

export default ReviewContent;

const styles = StyleSheet.create({
  container: {
    gap: 16,
  },
});
